import styled from '@emotion/styled'
import { memo, PropsWithChildren } from 'react'

const CatalogItemIconRoot = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  > svg {
    margin-right: var(--spacing-small);
    align-self: center;

    @media (max-width: 835px) {
      margin-right: var(--spacing-tiny);
    }
  }
`

export const CatalogItemIcon = memo(({ children }: PropsWithChildren) => {
  return <CatalogItemIconRoot>{children}</CatalogItemIconRoot>
})
